module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"endless-miles\"-in-torrance-california-c1c5c05d2d4c8200c13b18a3068cebfe.png";